













































import {ref, onMounted, computed} from "@nuxtjs/composition-api";
import { first } from "cypress/types/lodash";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";

export default {
  name: "VideoHero",
  components: { SfIcon, SfButton },
  props: {
    title: String,
    subtitle: String,
    buttonText: String,
    buttonUrl: String,
    videoUrl: String,
    mobileVideoUrl: String,
    mobileVideoPoster: {
      type: Object
    },
    videoPoster: {
      type: Object
    },
    themeType: String,
    autoplay: Boolean,
    mute: Boolean
  },
  setup(props) {
    const isMobile = ref(false);
    const videoWrapperRef = ref(null);
    const videoRef = ref(null);

    const showPoster = ref(true);
    const videoLoaded = ref(false);
    const paused = ref(false);
    const muted = ref(props.mute);
    const firstLoad = ref(true);

    const activeVideoUrl = computed(() => isMobile.value ? props.mobileVideoUrl : props.videoUrl);

    const showOverlay = computed(() => props.title || props.subtitle || props.buttonText);

    const onLoaded = () => {
      videoLoaded.value = true;

      if (!firstLoad.value) return;

      videoRef.value.volume = 0;

      if (props.autoplay) {
        videoRef.value.muted = true;
        videoRef.value.play();
      } else {
        paused.value = true;
      }

      firstLoad.value = false;
    };
    const onPlay = () => showPoster.value = false;
    const videoErrorHandler = () => showPoster.value = true;

    const checkAndToggleVideoState = () => {
      paused.value ? videoRef.value.pause() : videoRef.value.play();
    };

    const toggleVideoState = () => {
      if(!videoLoaded.value) return;
      paused.value = !videoRef.value.paused;
      checkAndToggleVideoState();
      checkAndToggleMuteState();
    };

    const checkAndToggleMuteState = () => {
      muted.value ? videoRef.value.volume = 0 : videoRef.value.volume = 1;
    };

    const toggleMuteState = () => {
      if(!videoLoaded.value) return;
      checkAndToggleMuteState();
      muted.value = !!videoRef.value.volume;
      videoRef.value.muted = !videoRef.value.muted;
      checkAndToggleMuteState();
    };

    const checkWidthAndSetIsMobile = (elementToCheck:any) => {
      const width = elementToCheck.width;
      const checkIfIsMobile = width < 1024;

      if (checkIfIsMobile !== isMobile.value) {
        showPoster.value = true;
        isMobile.value = checkIfIsMobile;
      }
    }

    onMounted(() => {

      if(ResizeObserver) {
        const videoWrapper = videoWrapperRef.value;
        const observer = new ResizeObserver(entries => {
          for (const entry of entries) {
            checkWidthAndSetIsMobile(entry.contentRect);
          }
        });

        checkWidthAndSetIsMobile(videoWrapper.getBoundingClientRect());

        observer.observe(videoWrapper);
      }

      if (props.autoplay) {
        muted.value = true;
      }
    });

    return {
      videoRef,
      videoWrapperRef,
      showPoster,
      showOverlay,
      onPlay,
      onLoaded,
      videoErrorHandler,
      toggleVideoState,
      toggleMuteState,
      paused,
      muted,
      isMobile,
      activeVideoUrl
    };
  },
};
